let demandsIntervalId: number | null = null;

export const applyCustomDemandsCss = () => {
  if (demandsIntervalId !== null) return; 
  demandsIntervalId = window.setInterval(() => {
    const host = document.querySelector('dr-flex-home-ui-app-demand-widget');
    const items = host?.querySelector('dsy-input-dropdown')?.shadowRoot
      ?.querySelector('dsy-list')?.shadowRoot?.querySelectorAll('dsy-list-element');
    if (!items || items.length === 0) return;
    items?.forEach(item => {
      const shadow = (item as HTMLElement).shadowRoot;
      const left = shadow?.querySelector<HTMLElement>('.left-hand-content');
      if (left) {
        left.style.cssText = `
          display: block !important;
          width: 100% !important;
          max-width: 100% !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          margin-right: 0.2rem !important;
        `;
      }
    });
    clearInterval(demandsIntervalId!);
    demandsIntervalId = null;
  }, 100); // Every 100ms
};

export const clearDemandsInterval = () => {
  if (demandsIntervalId !== null) {
    clearInterval(demandsIntervalId);
    demandsIntervalId = null;
  }
};